/**
 * Nhịp nhả chữ của luồng hỏi–đáp — port `lib/sse.ts` của native. Ba hằng dưới đây là kết quả ĐO, có bảng so ba phương
 * án; chúng ở một chỗ để không có bản thứ hai trôi khỏi bản đo.
 *
 * SSE đưa chữ về đúng nhịp mô hình sinh ra, mà nhịp ấy KHÔNG đều (Gemini trả mỗi mẩu chừng mười lăm từ, sáu mẩu trong
 * một giây rưỡi). Nối thẳng vào state là màn hình nhảy sáu cú; nên các mẩu vào một bộ đệm và một nhịp đều rút ra dần.
 */

/** 33 ms ≈ 30 khung/giây: đủ mượt, và bằng nửa số lần dựng lại so với bám 60 fps. */
export const NHIP_MS = 33;

/**
 * Mỗi nhịp rút 1/6 phần đang chờ — suy giảm hình học, cái đuôi mới là thứ quyết định. Đo trên nhịp Gemini thật (6 mẩu,
 * 505 ký tự): chia 12 → chữ xong sau mẩu cuối 1012 ms; chia 6 → 385 ms, tối đa 34 ký tự/nhịp; chia 4 → 286 ms nhưng
 * có nhịp nhả 47 ký tự (gần tám chữ hiện cùng lúc). 6 là chỗ dừng.
 */
export const SO_NHIP_XA = 6;

/** Sàn, để cái đuôi không bò từng ký tự — mười nhịp cho mười chữ cái trông như mạng đang lag. */
export const TOI_THIEU_KY_TU = 4;

/** Số ký tự rút ra khỏi bộ đệm ở MỘT nhịp. */
export function soKyTuRut(dangCho: number): number {
  return Math.max(TOI_THIEU_KY_TU, Math.ceil(dangCho / SO_NHIP_XA));
}
